<div class="load-more" title="Load more" (smScrollEnd)="!loading && loadMore.emit()">
  <div class="load-more__dot"></div>
</div>
